// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Ga5Xy","newExpiryDate":"styles_newExpiryDate__3HLB1","footer":"styles_footer__3SyE5"};